module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('display', [_c('path-line', {
    attrs: {
      "file-name": "fonts"
    },
    slot: "path"
  }), _vm._v(" "), _c('template', {
    slot: "sections"
  }, _vm._l((Object.keys(_vm.fonts)), function(fontGroup) {
    return _c('display-section', {
      attrs: {
        "title": fontGroup
      }
    }, [_c('p', {
      slot: "description"
    }, [_vm._v(_vm._s(_vm.descriptions[fontGroup.toLowerCase()]))]), _vm._v(" "), _vm._l((Object.keys(_vm.fonts[fontGroup])), function(font) {
      return _c('example', {
        key: font,
        attrs: {
          "var-name": font
        },
        slot: "examples"
      }, [_c('div', {
        staticClass: "font-display",
        class: [fontGroup, font]
      }, [_vm._v(_vm._s(font))])])
    })], 2)
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1a4c9944"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vars/fonts.vue
// module id = 1446
// module chunks = 1